import React from 'react'
import "./RegistrationCourse.css"; // עיצוב חיצוני
import { formatActivityDay,convertToIsraelTime } from '../../util/formatsForDate';


const RegistrationPackage = ({ onClose, course, onNext }) => {
    return (
    <div className="popup-overlay ">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
<div className='max-h-[80vh] overflow-y-scroll'>
        <img
          src={course?.linkImage_pack?`https://archivebureau.s3.eu-west-3.amazonaws.com/${course?.linkImage_pack}` :"https://images.pexels.com/photos/4391470/pexels-photo-4391470.jpeg"}
          alt="תמונה"
          className="popup-image"
        />

        <h3 className="popup-title">
          {/* רשימת מתנה לפוליסת האחריות המקצועית של לשכת ממוני הבטיחות */}
          {`${course?.name_pack} -${course.number_pack}`}
        </h3>
{/* 
        <p className="popup-description">
          ביום עיון נלמד, על אילו תחומים חלה פוליסת הבטיחות בעבודה:
          <br />
          • חידוש חוק, תקנות ונהלים רלוונטיים לממונה בטיחות <br />
          • ניהול סיכונים ודרכי מניעה <br />
          • דגשים חשובים בניהול מערכות בטיחות <br />
          • ועוד...
        </p> */}
        {/* <p className="popup-description">
          {course?.mySelfQualificationDto?.description}
        
        </p> */}

        <p className="popup-details ">
          {course?.openQulRegs_pack?.length>0 && <>
          <b className='underline'>אישורי כשירות לימי העיון:</b>
          {/* <b>מתי המפגש:</b> */}
          <br />
            {course?.openQulRegs_pack.map((openQulRegs_pack,index) => { return <div className='border border-spacing-1 text-[12px] border-blue-300 rounded-lg mb-2 p-2' >
                <b className='underline text-[14px]'>{openQulRegs_pack.mySelfQualificationDto.name} -{openQulRegs_pack.mySelfQualificationDto.number}</b>
            <br />
            <b className='text-[10px]'>מתי המפגש:</b>
            <br />
            {openQulRegs_pack?.mySelfQualificationDto?.activityDays.map((activityDay,index) => { return <> {formatActivityDay(activityDay)} <br /></> })}
            <b className='text-[10px]' >מיקום:</b> {openQulRegs_pack.mySelfQualificationDto?.place} <br />
            </div>})}
            {/* <br /> */}

          </>
          }
          {/* יום רביעי 15:00-20:00 <br />
          התכנסות: 10:00 <br /> */}
         
          
          <b> תאריך הכשרה:</b> {convertToIsraelTime(course?.dateStart_pack)} <br />

          <b>עלות:</b> {course?.lastPrice} ₪<br />
          {/* <b>מספר מפגשים:</b>{course?.daysWork==1? " 1 מפגש":course?.daysWork==0? " -": ` ${course?.daysWork} מפגשים`} */}
        </p>

        <button className="register-btn" onClick={onNext} disabled={course?.isRegistered}>{course?.isRegistered?"הינך רשומ/ה":"מעבר להרשמה"}</button>
      </div>
      </div>
    </div>
  )
}
export default RegistrationPackage